import {Row, Col, Image} from 'react-bootstrap';
import React, {Component} from 'react';
import classnames from 'classnames';

import './authenticationType.css';
import CheckboxCustom from "../checkbox_custom/CheckboxCustom";
import AM from './../../config/authenticationMethods';

export const VALID_AUTHENTICATION_VALUES = {[AM.QUESTIONS_AUTH]: AM.QUESTIONS_AUTH, [AM.CLAVE_UNICA_AUTH]: AM.CLAVE_UNICA_AUTH};

class AuthenticationType extends Component{
    constructor(props) {
        super(props);

        this.onChangeHandler = this.onChangeHandler.bind(this);
        this.onClickModalTrigger = this.onClickModalTrigger.bind(this);
    }

    onChangeHandler(event){
        event.preventDefault();
        const isModalTriggerImg = event.target.classList.contains('trigger-modal-img');
        if(!isModalTriggerImg){
            const valueSelected = event.currentTarget.getAttribute('data');
            if(Object.keys(VALID_AUTHENTICATION_VALUES).includes(valueSelected)){
                this.props.onChangeHandler(valueSelected);
            }
        }
    }

    onClickModalTrigger(event){
        event.preventDefault();
        const valueSelected = event.currentTarget.getAttribute('data');
        if(Object.keys(VALID_AUTHENTICATION_VALUES).includes(valueSelected)){
            this.props.onClickModalTrigger(valueSelected);
        }
    }

    render(){
        return (
            <Row className={'authentication-type'}>
                <Col xs={12} onClick={this.onChangeHandler} data={this.props.value}
                     className={classnames({
                         'authentication-type-with-border': this.props.checked,
                     })}
                >
                    <CheckboxCustom
                        name={this.props.name}
                        value={this.props.value}
                        checked={this.props.checked}
                        text={this.props.text}
                    />
                    {this.props.image &&
                    <Image src={this.props.image}
                       data={this.props.value}
                       onClick={this.onClickModalTrigger}
                       className={'trigger-modal-img'}
                    />}
                </Col>
            </Row>
        );
    }
}

export default AuthenticationType;